import {KeyLabel} from '../../../../shared/domain/key-label.model';
export enum ReportDimension {
  TOTAL = 'TOTAL',
  DAY = 'DAY',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  HOUR = 'HOUR',
  WIDGET = 'WIDGET',
  AD_UNIT = 'AD_UNIT',
  WIDGET_TYPE = 'WIDGET_TYPE',
  WIDGET_SIZE = 'WIDGET_SIZE',
  CONTENT_TYPE = 'CONTENT_TYPE',
  TAXONOMY = 'TAXONOMY',
  DEVICE_PLACEMENT = 'DEVICE_PLACEMENT',
  SITE = 'SITE',
  PUBLISHER = 'PUBLISHER',
  DEMAND_PARTNER = 'DEMAND_PARTNER',
  COMBINED_DIMENSIONS = 'COMBINED_DIMENSIONS',
  SB_DOMAIN = 'SB_DOMAIN',
  URL = 'URL',
  APP_BUNDLE = 'APP_BUNDLE',
  TIPALTI_ID = 'TIPALTI_ID'
}

export enum PromoReportDimension {
  TYPE = 'TYPE',
  DATE = 'DATE',
  FEED_NAME = 'FEED_NAME'
}

export enum PromoReportDimensionLabels {
  TYPE = 'Type',
  DATE = 'Date',
  FEED_NAME = 'Feed Name'
}

export const ReportDimensionLabels = {
  TOTAL: 'Total',
  DAY: 'Day',
  MONTH: 'Month',
  YEAR: 'Year',
  HOUR: 'Hour',
  WIDGET: 'Placement ID',
  AD_UNIT: 'Ad unit',
  WIDGET_TYPE: 'Widget type',
  WIDGET_SIZE: 'Placement size',
  CONTENT_TYPE: 'Content type',
  TAXONOMY: 'Taxonomy',
  DEVICE_PLACEMENT: 'Device placement',
  SITE: 'Site',
  PUBLISHER: 'Supply Partner',
  DEMAND_PARTNER: 'Demand partner',
  COMBINED_DIMENSIONS: 'Combined dimensions',
  SB_DOMAIN: 'Serverbid Domain',
  URL: 'Site (domain)',
  APP_BUNDLE: 'App Bundle',
  TIPALTI_ID: 'Tipalti ID'
};

export const ReportDimensionKL = () =>
  (Object.keys(ReportDimension).map(
      key => new KeyLabel<ReportDimension>(ReportDimension[key], ReportDimensionLabels[key]))
  );

export const PromoReportDimensionKL = () =>
  (Object.keys(PromoReportDimension).map(
      key => new KeyLabel<PromoReportDimension>(PromoReportDimension[key], PromoReportDimensionLabels[key]))
  );
